import React, { useState } from "react";
import { TopNavBar, TopBanner } from "../../components/TopNavBar";

import { Card } from "../../components/General";
import CurrentEvent from "./CurrentEvent";
import PeopleFlowChart from "./PeopleFlow";
import DailyFootfallRank from "./DailyFootfallRank";
import DailyEventRank from "./DailyEventRank";
import { useSelector } from "react-redux";
import { selectBuilding } from "../../features/store";

import SummaryRow from "./SummaryRow";

const Dashboard = ({ selectedBuilding, setSelectedBuilding }) => {
  const buildings = useSelector(selectBuilding);
  const [scrollTop, setScrollTop] = useState(0);
  return (
    <>
      <div
        className="dashboard"
        onScroll={(e) => {
          setScrollTop(e.currentTarget.scrollTop);
        }}
      >
        <TopNavBar
          shadow={scrollTop != 0}
          buildingDict={buildings}
          selectedBuilding={selectedBuilding}
          setSelectedBuilding={setSelectedBuilding}
        ></TopNavBar>
        <div className="dashboard-content">
          {Object.keys(buildings).length !== 0 ? (
            <>
              <TopBanner title={buildings[selectedBuilding].buildingName}>
                <SummaryRow currBuilding={buildings[selectedBuilding]} />
              </TopBanner>

              <div className="dashboard-non-banner">
                <div className="dashboard-row-wrap">
                  <div className="dashboard-row-rank">
                    <Card header={"Daily Footfall Rank"}>
                      <DailyFootfallRank selectedBuilding={selectedBuilding} />
                    </Card>
                  </div>
                  <div className="dashboard-row-rank">
                    <Card header={"Daily Event Rank"}>
                      <DailyEventRank selectedBuilding={selectedBuilding} />
                    </Card>
                  </div>
                </div>

                <Card header={"Current Events"}>
                  <CurrentEvent
                    currBuilding={buildings[selectedBuilding]}
                  ></CurrentEvent>
                </Card>
                <Card header={"Footfall"}>
                  <PeopleFlowChart
                    currBuilding={buildings[selectedBuilding]}
                  ></PeopleFlowChart>
                </Card>
              </div>
            </>
          ) : (
            <div className="dashboard-non-banner">
              <h4> No room available</h4>
              <p>Please contact admin for room access.</p>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Dashboard;
